/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";

export const ConfirmationIDFormatter = (cellContent, row, rowIndex) => {
  const { confirmation_id } = row;
  return (
    <>
      <div className="d-flex align-items-center">
        {confirmation_id ? confirmation_id : "-"}
      </div>
      <> </>
    </>
  );
};
